import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ColumnProfile extends BaseViewModel {
    Name: KnockoutObservable<string> = ko.observable("");
    ColumnProfileFieldsTab: TabPage;
    TabController: TabController;
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    CompleteCheck() {
        let isComplete = true;

        if (Bao.Utils.String.IsNullOrEmpty(this.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }

        return isComplete;
    }
    InitUrl() {
        return "ColumnProfile/Init";
    }
    init() {
        return super.init().then(() => {
            return super.InitTabController().then(() => {
                this.ColumnProfileFieldsTab = new TabPage();
                this.ColumnProfileFieldsTab.IsClosable(false);
                this.ColumnProfileFieldsTab.Url("ColumnProfileFieldsTab");
                this.TabController.AddTab(this.ColumnProfileFieldsTab);
            });
        });
    }
}
export default ColumnProfile;